export const SV = {
  "Open document": "Ãppna dokument",
  "Upload file": "Ladda upp fil",
  "Drop file here to upload": "SlÃ¤pp filen hÃ¤r fÃ¶r att ladda upp",
  "Disc": "Skiva",
  "URL": "URL",
  "FILE": "FIL",
  "SIZE": "STORLEK",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bytes",
  "Loading... Please wait.": "Laddar ... VÃ¤nta.",
  "Fit Width": "Passformsbredd",
  "Fit Height": "PassformshÃ¶jd",
  "Password protected document": "LÃ¶senordsskyddat dokument",
  "Password": "LÃ¶senord",
  "Open": "Ãppen",
  "Password Required": "LÃ¶senord krÃ¤vs",
  "Incorrect password": "fel lÃ¶senord",
  "Error": "Fel",
  "Something went wrong": "NÃ¥got gick fel",
  "Server is not available": "Servern Ã¤r inte tillgÃ¤nglig",
  "of": "av",
  "Please wait...": "VÃ¤nta..."
};
